import axios from 'axios';

import {
  EsqueciMinhasSenhaFormData,
  RedefinirSenhaFormData,
  ResponseObj,
  UsuarioLoginFormData,
  UsuarioNovoFormData,
  UsuarioEditFormData,
  UsuarioPacienteFormData,
  UsuarioQueryObj,
} from '../../../back/src/types';
import { Usuario } from '../../../back/src/entity/Usuario';
import { Gestacao } from '../../../back/src/entity/Gestacao';

const criaUsuario = async (formData: UsuarioNovoFormData): Promise<ResponseObj<Usuario>> => {
  const res = await axios.post<ResponseObj<Usuario>>('usuarios', formData);
  return res.data;
};

const criaUsuarioPaciente = async (
  formData: UsuarioPacienteFormData,
): Promise<ResponseObj<Usuario>> => {
  const res = await axios.post<ResponseObj<Usuario>>('usuarios/cadastrar_paciente', formData);
  return res.data;
};

const atualizaUsuario = async (
  usuarioId: number,
  formData: UsuarioEditFormData,
): Promise<ResponseObj<Usuario>> => {
  const res = await axios.put<ResponseObj<Usuario>>(
    `usuarios/${usuarioId}`,
    formData,
  );
  return res.data;
};

const usuarios = async (
  queryObj: UsuarioQueryObj = {},
): Promise<ResponseObj<Usuario[]>> => {
  const res = await axios.get<ResponseObj<Usuario[]>>('usuarios', { params: queryObj });
  return res.data;
};

const login = async (formData: UsuarioLoginFormData): Promise<ResponseObj<any>> => {
  const res = await axios.post<ResponseObj<any>>('login', formData);
  return res.data;
};


const checkToken = async (): Promise<ResponseObj<any>> => {
  const res = await axios.get<ResponseObj<any>>('check_token');
  return res.data;
};

const esqueciMinhaSenha = async (
  formData: EsqueciMinhasSenhaFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.post<ResponseObj<null>>('usuarios/esqueci_minha_senha', formData);
  return res.data;
};

const reenviarAtivacao = async (
  formData: EsqueciMinhasSenhaFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.post<ResponseObj<null>>('usuarios/reenviar_ativacao', formData);
  return res.data;
};

const redefinirSenha = async (formData: RedefinirSenhaFormData): Promise<ResponseObj<null>> => {
  const res = await axios.post<ResponseObj<null>>('usuarios/redefinir_senha', formData);
  return res.data;
};

const gestacoes = async (): Promise<ResponseObj<Gestacao[]>> => {
  const res = await axios.get<ResponseObj<Gestacao[]>>('usuarios/gestacoes');
  return res.data;
};

export default {
  atualizaUsuario,
  criaUsuario,
  criaUsuarioPaciente,
  usuarios,
  login,
  checkToken,
  esqueciMinhaSenha,
  redefinirSenha,
  reenviarAtivacao,
  gestacoes,
};
